import React from "react";

export default function AmbientBackground() {
  return (
    <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden">
      <div className="ambient-grid" />
      <div
        className="floating-orb"
        style={{ top: "-12%", left: "6%", animationDuration: "32s" }}
      />
      <div
        className="floating-orb"
        style={{ bottom: "-15%", right: "-10%", animationDuration: "36s", animationDelay: "8s" }}
      />
    </div>
  );
}

